import React from 'react';

const Test = () => {
    return (
        <div>
            <h1 className="header-title">The Internet will forgive you</h1>
        </div>
    );
}

export default Test;
